export default "__VITE_ASSET__Dc_gztjV__"